<template>
    <div class="habitaciones">
        <div class="header">
            <h1>HABITACIONES</h1>
        </div>
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'habitaciones'
}
</script>

<style scoped>
    .habitaciones {
        width: 100vw;
        height: 100vh;
    }
    .habitaciones > div.header {
        width: 100%;
        height: 10%;
        background-color: #2b2926;
        position: relative;
    }
    .habitaciones > .header > h1 {
        color: aliceblue;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
</style>



// WEBPACK FOOTER //
// src/components/Habitaciones/Habitaciones.vue